

















import { sample } from 'lodash';
import service from '@/services/background';
import MorphTarget from '@/components/MorphTarget.vue';

const fillColours = ['fc0', 'ffae93', 'e12729', '1112d0'];

export default {
  data() {
    // show backgrounds only for mobile or randomly for desktop
    const showBackground = this.$store.state.isMobile || Math.random() > 0.3;
    const background = showBackground && service.getRandomBackground();
    return {
      fill: '#' + sample(fillColours),
      background,
    };
  },
  components: {
    MorphTarget,
  },
} as IView;
